// extracted by mini-css-extract-plugin
export default {"table":"LiveSupport_table__8VdHY","header":"LiveSupport_header__EPrOj","row":"LiveSupport_row__ILH-c","unread_row":"LiveSupport_unread_row__iteXJ"};